import React from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import { Box, Dialog, IconButton, Link, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { OutlineButton, SolidButton } from '../components/Button';

const SURFPROTECT_URL = 'https://www.surfprotect.cz';
const COOKIE_NAME = 'lf_surfprotect_notice_dismissed';
const COOKIE_MAX_AGE = 3 * 24 * 60 * 60; // 3 days in seconds

function isDismissed(): boolean {
	return document.cookie.split('; ').some(c => c.startsWith(COOKIE_NAME + '='));
}

function setDismissed(): void {
	document.cookie = `${COOKIE_NAME}=1; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
}

interface IState {
	open: boolean
}

interface IProps extends WithTranslation {
}

class SurfprotectNotice extends React.Component<IProps, IState, WithTranslation> {

	constructor(props: IProps){
		super(props);
		this.state = { open: !isDismissed() };
		this.handleStay = this.handleStay.bind(this);
		this.handleContinue = this.handleContinue.bind(this);
	}

	handleStay() {
		setDismissed();
		this.setState({ open: false });
	}

	handleContinue() {
		setDismissed();
		window.location.href = SURFPROTECT_URL;
	}

	render() {
		const t = this.props.t;
		const ns = 'main';

		return <Dialog
			open={this.state.open}
			onClose={this.handleStay}
			aria-labelledby="surfprotect-notice-title"
			PaperProps={{ sx: { borderRadius: '20px', p: { xs: '24px', md: '40px' }, maxWidth: '640px' } }}
		>
			<IconButton aria-label="close" onClick={this.handleStay} sx={{ position: 'absolute', top: '12px', right: '12px' }}>
				<CloseIcon />
			</IconButton>

			<Typography id="surfprotect-notice-title" variant="h4" color="primary.main" sx={{ fontWeight: 600, pr: '32px', mb: '20px' }}>
				{t('surfprotect-notice.title', {ns})}
			</Typography>

			<Typography variant="body1" sx={{ mb: '12px' }}>
				{t('surfprotect-notice.continues', {ns})}
			</Typography>
			<Typography variant="body1" sx={{ mb: '32px' }}>
				<Trans i18nKey='surfprotect-notice.portfolio' ns={ns} components={[ <Link href={SURFPROTECT_URL} onClick={setDismissed} sx={{ display: 'inline' }} /> ]} />
			</Typography>

			<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'flex-end' }}>
				<OutlineButton onClick={this.handleStay}>{t('surfprotect-notice.stay', {ns})}</OutlineButton>
				<SolidButton onClick={this.handleContinue}>{t('surfprotect-notice.continue', {ns})}</SolidButton>
			</Box>
		</Dialog>
	}
}

export default withTranslation()(SurfprotectNotice);
